import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import JfmcTypePopup from "./shared/JfmcTypePopup";
import SettingsPanel from "./shared/SettingsPanel";
import Footer from "./shared/Footer";
import { withTranslation } from "react-i18next";
import { AuthProvider } from "./Context/AuthContext";


const App = ({ i18n }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);

  useEffect(() => {
    onRouteChanged();
  }, [location]);

  const onRouteChanged = () => {
    const body = document.querySelector("body");

    // ✅ Handle RTL layout toggle
    if (location.pathname === "/layout/RtlLayout") {
      body.classList.add("rtl");
      i18n.changeLanguage("ar");
    } else {
      body.classList.remove("rtl");
      i18n.changeLanguage("en");
    }

    // Scroll to top on route change
    window.scrollTo(0, 0);

    // ✅ Routes that should have full-page layout (no sidebar, no navbar)
    const fullPageLayoutRoutes = [
      "/",
      "/login-1",
      "/user-pages/register-1",
      "/user-pages/forgot-password",
      "/user-pages/lockscreen",
      "/error-pages/error-404",
      "/error-pages/error-500",
      "/general-pages/landing-page",
    ];

    // ✅ Only update state (no DOM manipulation)
    setIsFullPageLayout(fullPageLayoutRoutes.includes(location.pathname));
  };
  useEffect(() => {
    const token = localStorage.getItem("authData");
    const publicRoutes = [
      "/",
      "/login-1",
      "/user-pages/forgot-password",
      "/user-pages/lockscreen",
    ];

    if (!token && !publicRoutes.includes(location.pathname)) {
      navigate("/");
    }
  }, [location.pathname, navigate]);

  return (
    // <div className="container-scroller sidebar-fixed">
    //   {!isFullPageLayout && <Navbar />}
    //   <div className="container-fluid page-body-wrapper">
    //     {!isFullPageLayout && <Sidebar />}
    //     <div className="main-panel">
    //       <div className="content-wrapper">
    //         <AppRoutes />
    //         {!isFullPageLayout && <SettingsPanel />}
    //       </div>
    //       {!isFullPageLayout && <Footer />}
    //     </div>
    //   </div>
    // </div>
    <>
      {isFullPageLayout ? (
        // 🔹 Full Page Layout (for login/register/error pages)
        <div className="container-scroller full-page-wrapper">
          <AppRoutes />
        </div>
      ) : (
        // 🔹 Main Layout (with sidebar, navbar, footer)
        <div className="container-scroller sidebar-fixed">
          <JfmcTypePopup />
          <Navbar />
          <div className="container-fluid page-body-wrapper">
            <Sidebar />
            <div className="main-panel">
              <div className="content-wrapper">
                <AppRoutes />
                <SettingsPanel />
              </div>
              <Footer />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const AppWithRouter = (props) => (
  <AuthProvider>
    <App {...props} />
  </AuthProvider>
);

export default withTranslation()(AppWithRouter);
